<template>
  <div class="images-contaner" :style="{overflowY: 'hidden'}">
    <div class="filters">
      <!-- <RT :options="['列表', '滑動']" :defaultValue="slide?'滑動':'列表'" @input="slide=$event==='滑動'"/> -->
      <div :style="{marginInline: 'auto'}"/>
      <label class="addimage" for="addimage"><span></span><input type="file" id="addimage" @change="upload">新增圖片</label>
    </div>
    <div class="images">
      <div>
        <!-- <img v-if="org.image" :src="`${VUE_APP_HOST}${org.image}`" :alt="`${org.name}首圖`"> -->
        <label v-for="(img, i) in (org.imageArray || [])" :key="`${org.name}-${i}`" class="delete">
        <img :src="`${VUE_APP_HOST}${img}`" :alt="`${org.name}-${i}`">
        <button @click="deleteImg=img"></button>
        </label>
      </div>
    </div>
    <DialogDef2 v-if="deleteImg" :show="deleteImg" :label="'刪除圖片'" @close="deleteImg=null">
      <div class="dialogConfirm">
        <div>確定要刪除圖片嗎?</div>
        <BtnsS @cancel="deleteImg=null" @save="deleteImage(deleteImg)" :save="'確定'"/>
      </div>
    </DialogDef2>
  </div>
</template>

<script>
import { postapi } from '../../../../store/fetch'
const { VUE_APP_HOST } = process.env
export default {
  props: ['org', 'mode'],
  components: {},
  data () {
    return {
      VUE_APP_HOST,
      slide: false,
      deleteImg: null
    }
  },
  methods: {
    async upload (ev) {
      const image = await this.$store.dispatch('uploadFile', { event: ev, folder: 'product' })
      console.log('[image]', image)
      const r = await postapi(`rest_product/${this.mode}/push/image/${this.org._id}`, { image: `/product/${image.filename}` })
      if (r) {
        this.$emit('update', { ...this.org, imageArray: (r.imageArray || []) })
      }
    },
    async deleteImage (img) {
      const r = await postapi(`rest_product/${this.mode}/pull/image/${this.org._id}`, { image: img })
      if (r) {
        this.$emit('update', { ...this.org, imageArray: (r.imageArray || []) })
        this.deleteImg = null
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.dialogConfirm {
  display: flex;
  flex-direction: column;
  font-size: 24px;
  padding: 30px;
  gap: 20px;
}
.images-contaner {
  padding: 40px 0;
  .filters {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .addimage {
    width: 155px;
    height: 50px;
    background-color: var(--color-pri);
    display: flex;
    border-radius: 25px;
    color: #FFFFFF;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    letter-spacing: .1em;
    font-weight: 400;
    font-size: 18px;
    gap: 10px;
    text-align: start;
    white-space: nowrap;
    input[type=file] {
      display: none;
    }
    &>span {
      background-color: #FFFFFF;
      mask-image: url(svg/btn/add.svg);
      display: inline-flex;
      width: 25px;
      height: 25px;
      mask-position: center;
      mask-size: contain;
      mask-repeat: no-repeat;
    }
  }
}
.images {
  overflow-y: auto;
  max-height: calc(100vh - 270px);
  margin-top: 20px;
  width: 900px;
  &>div{
    width: 100%;
    display: flex;
    flex-direction: column;
    img {
      width: 900px;
      height: fit-content;
      min-height: fit-content;
      resize: both;
      background-color: #CACACA;
      min-height: 100px;
    }
    label {
      max-width: 900px;
    }
    .delete {
      z-index: 1;
      width: 900px;
      max-width: 900px;
      position: relative;
    }
    .delete > button {
      position: absolute;
      top: 20px;
      right: 20px;
      z-index: 2;
      margin: auto;
      display: block;
      width: 50px;
      height: 50px;
      background-color: #00000099;
      display: flex;
      align-items: center;
      justify-content: center;
      &::before {
        content: '';
        display: inline-flex;
        width: 35px;
        height: 35px;
        mask-image: url(/svg/btn/closeDialog.svg);
        background-color: #FFFFFF;
        mask-repeat: no-repeat;
        mask-position: center;
        mask-size: contain;
      }
    }
  }
}
</style>
